import axios from "axios";

// const API = axios.create({ baseURL: 'http://localhost:5000'})
const API = axios.create({ baseURL: process.env.REACT_APP_API });

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem("profile")).token}`;
  }

  return req;
});

axios.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem("profile")).token}`;
  }

  return req;
});

// Simple client-side cache to avoid repeated GET calls during navigation.
const __cache = new Map();
const cachedGet = async (key, ttlMs, fetcher) => {
  const now = Date.now();
  const cached = __cache.get(key);
  if (cached) {
    if (cached.response && now - cached.at < ttlMs) return cached.response;
    if (cached.promise) return cached.promise;
  }
  const promise = fetcher()
    .then((res) => {
      __cache.set(key, { response: res, at: Date.now() });
      return res;
    })
    .catch((err) => {
      __cache.delete(key);
      throw err;
    });
  __cache.set(key, { promise, at: now });
  return promise;
};

// export const fetchInvoices =() => API.get('/invoices')
export const fetchInvoice = (id) => API.get(`/invoices/${id}`);
export const fetchInvoicesByClient = ({
  page,
  rowsPerPage,
  id,
  startDate,
  endDate,
}) =>
  API.post(`/invoices/client`, { page, rowsPerPage, id, startDate, endDate });
export const addInvoice = (invoice) => API.post("/invoices", invoice);
export const updateInvoice = (id, updatedInvoice) =>
  API.post(`/invoices/${id}`, updatedInvoice);
export const markInvoiceForPrint = (id) =>
  API.post(`/invoices/${id}/mark-print`);
export const deleteInvoice = (id) => API.post(`/invoices/delete/${id}`);
export const fetchInvoicesByUser = (searchQuery) =>
  API.get(`/invoices/user?searchQuery=${searchQuery.search}`);
// Lightweight invoice list for dashboards/stats (no heavy populate).
export const fetchInvoices = () => API.get("/invoices/summary");
export const fetchMinimalInvoices = (
  page = 1,
  limit = 25,
  filters = {}
) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params.append(key, value);
    }
  });

  return API.get(`/invoices/minimal?${params.toString()}`);
};
export const fetchInvoicesByDateRange = (startDate, endDate) => 
  API.get(`/invoices/by-date-range?startDate=${startDate}&endDate=${endDate}`);
export const fetchInvoicesCount = () =>
  cachedGet("invoices-count", 5000, () => API.get("/invoices/count"));

export const fetchDeletedInvoices = (page = 1, limit = 25, startDate = null, endDate = null) => {
  let url = `/invoices/deleted?page=${page}&limit=${limit}`;
  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  }
  return API.get(url);
};

export const fetchAllDeletedInvoices = (startDate = null, endDate = null) => {
  let url = `/invoices/deleted/all`;
  if (startDate && endDate) {
    url += `?startDate=${startDate}&endDate=${endDate}`;
  }
  return API.get(url);
};
export const fetchCanceledInvoices = (page = 1, limit = 25, startDate = null, endDate = null) => {
  let url = `/invoices/canceled?page=${page}&limit=${limit}`;
  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  }
  return API.get(url);
};
export const fetchComplimentaryInvoices = (page = 1, limit = 25, startDate = null, endDate = null) => {
  let url = `/invoices/complimentary?page=${page}&limit=${limit}`;
  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  }
  return API.get(url);
};
export const softdeleteInvoice = (id) => API.post(`/invoices/softdelete/${id}`);
export const cancelInvoice = (id) => API.post(`/invoices/cancel/${id}`);
// export const verifyQr = (qrToken) => API.post("/invoices/verify-qr", { qrToken });
// export const verifyQr = (qrToken) =>
//   API.post("/invoices/verify-qr", {
//     qrToken,
//   });

// api/index.js

export const verifyQr = (qrToken, staffId,) =>
  API.post("/invoices/verify-qr", { qrToken, staffId });


export const createCashTransaction = (transaction) => API.post("/cash-transactions", transaction);
export const fetchCashTransactions = (startDate, endDate) =>
  API.get(`/cash-transactions?startDate=${startDate}&endDate=${endDate}`);
export const closeRegister = (data) => API.post("/cash-transactions/close", data);
export const fetchCashSummary = (date) => API.get(`/cash-transactions/summary?date=${date}`);
export const generateDailyReport = (date) => API.get(`/cash-transactions/report?date=${date}`);

export const updateStaffCommissionDetail = (id, updatedStaffCommissionDetail) =>
  API.post(`/staffCommissionDetails/update/${id}`, updatedStaffCommissionDetail);
export const fetchStaffCommissionDetail = (id) =>
  API.get(`/staffCommissionDetails/${id}`);
export const addStaffCommissionDetail = (staffCommissionDetail) =>
  API.post("/staffCommissionDetails", staffCommissionDetail);

export const fetchBogies = () =>
  cachedGet("bogies", 60000, () => API.get("/bogies"));
export const createBogie = (data) => API.post("/bogies", data);
export const updateBogie = (id, data) => API.post(`/bogies/update/${id}`, data);
export const deleteBogie = (id) => API.post(`/bogies/delete/${id}`);
export const toggleBogieActive = (id) => API.post(`/bogies/toggle-active/${id}`);


export const updateStaffCommissionDetails = async (
  updatedStaffCommissionDetails
) => {
  try {
    console.log(
      "Update StaffCommissionDetails from API index: ",
      updatedStaffCommissionDetails
    );
    const response = await API.post(
      `/staffCommissionDetails/update`,
      updatedStaffCommissionDetails
    );

    if (response.status === 200) {
      console.log("staffCommissionDetails updated successfully");
    } else {
      console.error("Failed to update staffCommissionDetails");
    }
  } catch (error) {
    console.error(
      "An error occurred while updating staffCommissionDetails:",
      error
    );
  }
};
export const deleteStaffCommissionDetail = (id) =>
  API.post(`/staffCommissionDetails/delete/${id}`);
export const fetchStaffCommissionDetailsByUser = (searchQuery) =>
  API.get(`/staffCommissionDetails/user?searchQuery=${searchQuery.search}`);
export const fetchStaffCommissionDetails = () =>
  API.get("/staffCommissionDetails");

export const fetchPurchase = (id) => API.get(`/purchases/${id}`);
export const addPurchase = (purchase) => API.post("/purchases", purchase);
export const updatePurchase = (id, updatedPurchase) =>
  API.post(`/purchases/${id}`, updatedPurchase);
export const deletePurchase = (id) => API.post(`/purchases/delete/${id}`);
export const fetchPurchasesByUser = (searchQuery) =>
  API.get(`/purchases/user?searchQuery=${searchQuery.search}`);
export const fetchPurchases = () => API.get("/purchases");

export const fetchMeeting = (id) => API.get(`/meetings/${id}`);
export const addMeeting = (meeting) => API.post("/meetings", meeting);
export const updateMeeting = (id, updatedMeeting) =>
  API.post(`/meetings/${id}`, updatedMeeting);
export const deleteMeeting = (id) => API.post(`/meetings/delete/${id}`);
export const fetchPaymentsByClient = ({
  page,
  rowsPerPage,
  id,
  startDate,
  endDate,
}) =>
  API.post(`/meetings/client`, { page, rowsPerPage, id, startDate, endDate });
export const fetchMeetingsByUser = (searchQuery) =>
  API.get(`/meetings?searchQuery=${searchQuery.search}`);
export const fetchMeetings = () => API.get("/meetings");

export const fetchClient = (id) => API.get(`/clients/${id}`);
export const fetchClients = (page) => API.get(`/clients?page=${page}`);
export const addClient = (client) => API.post("/clients", client);
export const updateClient = (id, updatedClient) =>
  API.post(`/clients/${id}`, updatedClient);
export const deleteClient = (id) => API.post(`/clients/delete/${id}`);
export const fetchClientsByUser = (searchQuery) =>
  API.get(`/clients/user?searchQuery=${searchQuery.search}`);
export const fetchAllClients = () => API.get("/clients");

export const fetchSupplier = (id) => API.get(`/staff/${id}`);
export const fetchSuppliers = (page) => API.get(`/staff?page=${page}`);
export const addSupplier = (client) => API.post("/staff", client);
export const updateSupplier = (id, updatedSupplier) =>
  API.post(`/staff/${id}`, updatedSupplier);
export const deleteSupplier = (id) => API.post(`/staff/delete/${id}`);
export const fetchSuppliersByUser = (searchQuery) =>
  API.get(`/staff/user?searchQuery=${searchQuery.search}`);
export const fetchAllSuppliers = () => API.get("/staff");

// export const adminSignIn =(formData)=> API.post('/users/adminSignin', formData)
export const adminSignUp = (formData) =>
  API.post("/users/adminSignup", formData);
export const signIn = (formData) => API.post("/users/signin", formData);
export const signUp = (formData) => API.post("/users/signup", formData);
export const forgot = (formData) => API.post("/users/forgot", formData);
export const reset = (formData) => API.post("/users/reset", formData);
export const fetchUsers = () => API.get("/users");
export const deleteUser = (id) => API.post(`/users/delete/${id}`);
export const updateUser = (id, updatedUser) =>
  API.post(`/users/${id}`, updatedUser);

export const fetchProfilesBySearch = (searchQuery) =>
  API.get(
    `/profiles/search?searchQuery=${
      searchQuery.search || searchQuery.year || "none"
    }`
  );
export const fetchProfile = (id) => API.get(`/profiles/${id}`);
export const fetchProfiles = () => API.get("/profiles");
export const fetchProfilesByUser = (searchQuery) => {
  const userId =
    typeof searchQuery === "string" || typeof searchQuery === "number"
      ? searchQuery
      : searchQuery?.search;
  return API.get(`/profiles/user?searchQuery=${userId ?? ""}`);
};
// console.log("fetchProfilesByUser called in client")
// console.log(searchQuery.search)

export const createProfile = (newProfile) => API.post("/profiles", newProfile);
export const updateProfile = (id, updatedProfile) =>
  API.post(`/profiles/${id}`, updatedProfile);
export const deleteProfile = (id) => API.post(`/profiles/delete/${id}`);

export const createFuturePriceList = (futurePriceList) =>
  API.post("/items/future-prices", futurePriceList);
export const fetchFuturePriceList = () => API.get("/items/future-prices");
export const updateFuturePrice = (id, priceData) =>
  API.post(`/items/future-prices/update/${id}`, priceData);
export const deleteFuturePrice = (id) => API.post(`/items/future-prices/delete/${id}`);

export const fetchItem = (id) => API.get(`/items/${id}`);
export const fetchItems = () => API.get("/items");
export const addItem = (item) => API.post("/items", item);
export const addItems = (item) => API.post("/items/file", item);
export const updateItem = (id, updatedItem) =>
  API.post(`/items/update/${id}`, updatedItem);
export const toggleItemStatus = (id) => API.post(`/items/toggle/${id}`);

export const deleteItem = (id) => API.post(`/items/delete/${id}`);
export const deleteItemsByCategoryId = (id) => API.post(`/items/deleteByCategoryId/${id}`);
export const fetchItemsByUser = (searchQuery) =>
  API.get(`/items/user?searchQuery=${searchQuery.searcategoriesch}`);
export const updateItems = (items) => API.post("/items/update", items);

export const fetchUnits=()=>API.get(`/units`)
export const addUnit=(unit)=>API.post(`/units`, unit)
export const addUnits=(unit)=>API.post(`/units/createAll`, unit)
export const getUnitById=(id)=>API.get(`/units/${id}`)
export const mapUnit = (mappingData) => API.post("/units/map", mappingData);

export const deleteBasicUnit = (id) => API.post(`/units/delete-basic/${id}`);
export const deleteMappedUnit = (id) => API.post(`/units/delete-mapped/${id}`);
export const updateBasicUnit = (id, unit) => API.post(`/units/update-basic/${id}`, unit);
export const updateMappedUnit = (id, unit) => API.post(`/units/update-mapped/${id}`, unit);


// Unit API Calls
export const fetchUnitMappings = () => API.get("/units/mappings");
export const createUnit = (newUnit) => API.post("/units", newUnit);
export const convertUnits = (conversionData) => API.post("/units/convert", conversionData);
export const updateUnit = (id, updatedUnit) => API.post(`/units/update/${id}`, updatedUnit);
export const deleteUnit = (id) => API.post(`/units/delete/${id}`);
export const deleteUnitMapping = (id) => API.post(`/units/delete-mapping/${id}`);
export const updateUnitMapping = (id, mappingData) => axios.post(`/unit-mappings/update/${id}`, mappingData);



export const fetchCategory = (id) => API.get(`/categories/${id}`);
export const addCategory = (stock) => API.post("/categories", stock);



export const updateCategory = (id, updatedCategory) =>
  API.post(`/categories/${id}`, updatedCategory);
export const toggleCategoryStatus = (id) => API.post(`/categories/toggle/${id}`);
export const deleteCategory = (id) => API.post(`/categories/delete/${id}`);
export const fetchCategoriesByUser = (searchQuery) =>
  API.get(`/categories/user?searchQuery=${searchQuery.search}`);
export const fetchCategories = () => API.get("/categories");

export const fetchStock = (id) => API.get(`/stocks/${id}`);
export const addStock = (stock) => API.post("/stocks", stock);
export const updateStock = (id, updatedStock) =>
  API.post(`/stocks/${id}`, updatedStock);
export const deleteStock = (id) => API.post(`/stocks/delete/${id}`);
export const deleteStockById = (id, type) => API.post(`/stocks/${type}/${id}`);
export const fetchStocksByUser = (searchQuery) =>
  API.get(`/stocks/user?searchQuery=${searchQuery.search}`);
export const fetchStocks = () => API.get("/stocks");

export const getCurrentStockQuantity=(itemId)=>API.get(`/stocks/quantity/${itemId}`);




export const fetchStockAdjustment = (id) => API.get(`/stockAdjustments/${id}`);
export const addStockAdjustment = (stockAdjustment) =>
  API.post("/stockAdjustments", stockAdjustment);
export const updateStockAdjustment = (id, updatedStockAdjustment) =>
  API.post(`/stockAdjustments/${id}`, updatedStockAdjustment);
export const deleteStockAdjustment = (id) =>
  API.post(`/stockAdjustments/delete/${id}`);
export const fetchStockAdjustmentsByUser = (searchQuery) =>
  API.get(`/stockAdjustments?searchQuery=${searchQuery.search}`);
export const fetchStockAdjustments = () => API.get("/stockAdjustments");

export const fetchStaff = (id) => API.get(`/staff/${id}`);
export const fetchStaffByPage = (page) => API.get(`/staff?page=${page}`);
export const addStaff = (client) => API.post("/staff", client);
export const updateStaff = (id, updatedStaff) =>
  API.post(`/staff/${id}`, updatedStaff);
export const deleteStaff = (id) => API.post(`/staff/delete/${id}`);
export const fetchStaffByUser = (searchQuery) =>
  API.get(`/staff/user?searchQuery=${searchQuery.search}`);
export const fetchAllStaff = () => API.get("/staff");

// New User Type API Calls
// User Type API Calls
export const fetchUserTypes = () => API.get("/users/userTypes");
export const createUserType = (userTypeData) => {
  console.log("API createUserType called with URL:", "/users/userTypes", "data:", userTypeData); // Debug
  return API.post("/users/userTypes", userTypeData);
};
export const updateUserType = (name, userTypeData) => {
  console.log("Updating user type with URL:", `/users/userTypes/update/${name}`); // Debug
  return API.post(`/users/userTypes/update/${name}`, userTypeData);
};
export const deleteUserType = (name) => {
  console.log("Deleting user type with URL:", `/users/userTypes/delete/${name}`); // Debug
  return API.post(`/users/userTypes/delete/${name}`);
};
export const getUserPermissions = () =>
  cachedGet("user-permissions", 60000, () => API.get("/users/permissions"));

export const fetchBookedSeats = (tripDate, tripNumber) =>
  cachedGet(
    `booked-seats:${tripDate}:${tripNumber}`,
    5000,
    () =>
      API.get(
        `/invoices/booked-seats?tripDate=${tripDate}&tripNumber=${tripNumber}`
      )
  );

export const resetSeats = (tripDate, tripNumber) =>
  API.post('/invoices/reset-seats', { tripDate, tripNumber });

export const fetchTripNumber = (tripDate) =>
  cachedGet(
    `trip-number:${tripDate}`,
    5000,
    () => API.get(`/invoices/trip-number?tripDate=${tripDate}`)
  );

export const resetSeatsAndIncrement = (tripDate) =>
  API.post('/invoices/reset-seats-and-increment', { tripDate });

// Seatless ticket mode toggle helpers
export const getSeatlessMode = async (userId) => {
  const res = await API.get(`/profiles/user?searchQuery=${userId}`);
  return !!res?.data?.data?.seatlessTicketMode;
};

export const setSeatlessMode = async (profileId, enabled) => {
  return API.post(`/profiles/${profileId}`, { seatlessTicketMode: !!enabled });
};

// Printer Location API Calls
export const fetchPrinterLocation = (profileId) => API.get(`/printer-location/${profileId}`);

export const savePrinterLocation = (profileId, printerLocationData) => {
  return  API.post(`/printer-location/${profileId}`, printerLocationData);
}

export const deletePrinterLocation = (profileId) => {
  return API.post(`/printer-location/${profileId}/delete`);
}

export const rePrintInvoice = (fileName, data) => {
  return API.post(`/print-invoice/${fileName}`, data);
}

export const generateHtmlTemplet = (fileName, data) => {
  return API.post(`/generate-invoice-template/${fileName}`, data);
};

export const permanentInvoiceDelete = (id) => {
  const profile = JSON.parse(localStorage.getItem("profile"));

  const userType = profile?.result?.userType || [];
  
  console.log("Sending userType:", userType);
  

  return API.post(
    `/invoices/delete-invoice-permanently/${id}`,
    { userType } // BODY
  );
};


export const fetchQrScanReport = ({
  station,
  startDate,
  endDate,
  invoiceNumber,
  status,
  page = 1,
  limit = 10
}) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  if (station) params.append("station", station);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (invoiceNumber) params.append("invoiceNumber", invoiceNumber);
  if (status) params.append("status", status);

  return API.get(`/qrScanReport/qrReport?${params.toString()}`);
};

// Fast API for pending scans only
export const fetchPendingQrScans = ({
  station,
  invoiceNumber,
  page = 1,
  limit = 10
}) => {
  let query = `page=${page}&limit=${limit}&`;

  if (station) query += `station=${station}&`;
  if (invoiceNumber) query += `invoiceNumber=${invoiceNumber}&`;

  // Remove trailing '&' if present
  if (query.endsWith("&")) query = query.slice(0, -1);

  return API.get(`/qrScanReport/pending?${query}`);
};

// Very fast stats API for dashboard
export const fetchQrScanStats = (station) => {
  const query = station ? `station=${station}` : "";
  return API.get(`/qrScanReport/stats${query ? `?${query}` : ""}`);
};

